import React from 'react'
import SevenStar from './7star'
import SevenStarJasem from './7starjasem'
import Syzygy from './syzygy'

const EditBillingDetailsDialog = ({ company = '', billingDetails = {}, open, onClose, onUpdate }) => {

    return <SevenStar billingDetails={billingDetails} open={open} onClose={onClose} onUpdate={onUpdate} />

    /*
    switch (company) {
        case '7star':
            return <SevenStar billingDetails={billingDetails} open={open} onClose={onClose} onUpdate={onUpdate} />
        case '7starjasem':
            return <SevenStarJasem billingDetails={billingDetails} open={open} onClose={onClose} onUpdate={onUpdate} />
        case 'syzygy':
            return <Syzygy billingDetails={billingDetails} open={open} onClose={onClose} onUpdate={onUpdate} />
        default:
            return <></>
    }
            */
}

export default EditBillingDetailsDialog